import React from "react"

import InputTrendField from "../../../modals/GraphEditModal/InputTrendField"
import { registration } from "../../../modals/GraphEditModal"
import DropdownTrendField from "../../../modals/GraphEditModal/DropdownTrendField"

export default function StyleEditingGroup({ rowStyle, obs, intl, adjustMetric, intField, modifierField }) {
  return (
    <div style={rowStyle} className={"text-center"}>
      <div className={"col-6"}>
        <div>
          <label style={{ margin: "0" }}>{registration[`${intField}_trend_field`](intl)}:</label>
        </div>
        <div>
          <InputTrendField
            obv={obs}
            field={intField}
            width={"75%"}
            updateField={(opt) => adjustMetric(obs, opt, intField)}
          />
        </div>
      </div>
      <div className={"col-6"}>
        <div>
          <label style={{ margin: "0" }}>{registration[`${modifierField}_trend_field`](intl)}:</label>
        </div>
        <div>
          <DropdownTrendField
            obv={obs}
            id={`${modifierField}-trend-toggle`}
            field={modifierField}
            intl={intl}
            updateField={(opt) => adjustMetric(obs, opt, modifierField)}
          />
        </div>
      </div>
    </div>
  )
}
